export default "__VITE_ASSET__ZkiDu5qS__"